<template>
  <div id="app">
    <CommonHeader />
    <ScrollTop />
    <router-view />
    <CommonFooter />
  </div>
</template>

<script>
import CommonHeader from './components/common-header/index.vue'
import CommonFooter from './components/common-footer/index.vue'
import ScrollTop from './components/scroll-top.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    CommonHeader,
    CommonFooter,
    ScrollTop
  },
  async created() {
    await this.getWebPage()
  },
  methods: {
    ...mapActions('common', ['getWebPage']),
  },
}
</script>

<style lang="scss">
#app {
  min-width: 1330px;
  min-height: 100vh;
}
</style>
